import React from 'react';
export function WordmarkOptions() {
  return <div className="min-h-screen bg-slate-50 py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-793">
      <div className="max-w-7xl mx-auto" data-id="element-794">
        <div className="text-center mb-16" data-id="element-795">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-796">
            Wordmark Explorations
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-797">
            12 typography-focused logo variations inspired by the Bold Wordmark
            concept. Exploring weight, spacing, case, and subtle accents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-798">
          {/* 1. The Original Inspiration */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-799">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-800">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-801">
                1. The Original
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-802">
                Black / Tighter / Gradient AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-803">
              <div className="flex items-baseline" data-id="element-804">
                <span className="text-3xl font-black text-slate-900 tracking-tighter" data-id="element-805">
                  SWEDENMARK
                </span>
                <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 ml-1" data-id="element-806">
                  AI
                </span>
                <div className="w-2 h-2 rounded-full bg-emerald-500 ml-1 mb-1" data-id="element-807"></div>
              </div>
            </div>
          </div>

          {/* 2. Minimalist Wide */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-808">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-809">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-810">
                2. Minimalist Wide
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-811">
                Light / Widest / Bold AI
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-812">
              <div className="flex items-center" data-id="element-813">
                <span className="text-xl font-light text-slate-800 tracking-[0.3em] uppercase" data-id="element-814">
                  Swedenmark
                </span>
                <span className="text-xl font-bold text-blue-600 ml-2" data-id="element-815">AI</span>
              </div>
            </div>
          </div>

          {/* 3. Lowercase Tech */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-816">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-817">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-818">
                3. Lowercase Tech
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-819">
                Lowercase / Tight / Colored Dot
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-820">
              <div className="flex items-baseline" data-id="element-821">
                <span className="text-3xl font-bold text-slate-800 tracking-tight" data-id="element-822">
                  swedenmark
                </span>
                <span className="text-3xl font-light text-slate-400 ml-1" data-id="element-823">
                  ai
                </span>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 ml-1" data-id="element-824"></div>
              </div>
            </div>
          </div>

          {/* 4. The Pill Badge */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-825">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-826">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-827">
                4. The Pill Badge
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-828">
                Bold / Badge Accent
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-829">
              <div className="flex items-center" data-id="element-830">
                <span className="text-2xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-831">
                  Swedenmark
                </span>
                <span className="ml-2 px-2 py-0.5 bg-blue-600 text-white text-sm font-bold rounded-full tracking-wider" data-id="element-832">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 5. Two-Tone Split */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-833">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-834">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-835">
                5. Two-Tone Split
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-836">
                Bold + Light / Monochromatic
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-837">
              <div className="flex items-center" data-id="element-838">
                <span className="text-3xl font-black text-[#0f2546] tracking-tighter uppercase" data-id="element-839">
                  SWEDEN
                </span>
                <span className="text-3xl font-light text-[#0f2546] tracking-tighter uppercase" data-id="element-840">
                  MARK
                </span>
                <span className="text-3xl font-bold text-blue-500 ml-1.5" data-id="element-841">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 6. Superscript */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-842">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-843">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-844">
                6. Superscript
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-845">
                Heavy / Elevated Accent
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-846">
              <div className="flex items-start" data-id="element-847">
                <span className="text-3xl font-extrabold text-slate-900 tracking-tight uppercase" data-id="element-848">
                  SWEDENMARK
                </span>
                <span className="text-sm font-black text-purple-600 ml-0.5 mt-1" data-id="element-849">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 7. Tech Stacked */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-850">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-851">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-852">
                7. Tech Stacked
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-853">
                Stacked / High Contrast
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-854">
              <div className="flex flex-col items-start leading-none" data-id="element-855">
                <span className="text-sm font-bold text-slate-500 tracking-[0.3em] uppercase mb-1" data-id="element-856">
                  Swedenmark
                </span>
                <span className="text-4xl font-black text-blue-600 tracking-tighter" data-id="element-857">
                  AI Systems
                </span>
              </div>
            </div>
          </div>

          {/* 8. The Underline */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-858">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-859">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-860">
                8. The Underline
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-861">
                Clean / Structural
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-862">
              <div className="relative inline-block" data-id="element-863">
                <div className="flex items-baseline pb-1" data-id="element-864">
                  <span className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-865">
                    Swedenmark
                  </span>
                  <span className="text-2xl font-bold text-slate-400 ml-1.5" data-id="element-866">
                    AI
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500" data-id="element-867"></div>
              </div>
            </div>
          </div>

          {/* 9. Continuous Sweep */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-868">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-869">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-870">
                9. Continuous Sweep
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-871">
                Full Gradient / Tight
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-slate-900" data-id="element-872">
              <span className="text-3xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400" data-id="element-873">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 10. Monospace Vibe */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-874">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-875">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-876">
                10. Monospace Vibe
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-877">
                Technical / Code-like
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-white" data-id="element-878">
              <div className="flex items-center font-mono" data-id="element-879">
                <span className="text-lg font-bold text-slate-800 tracking-tight" data-id="element-880">
                  swedenmark
                </span>
                <span className="text-lg font-bold text-emerald-500" data-id="element-881">_ai</span>
              </div>
            </div>
          </div>

          {/* 11. Editorial Serif-Style */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-882">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-883">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-884">
                11. Editorial
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-885">
                Classic / Refined
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#faf8f5]" data-id="element-886">
              <div className="flex items-baseline" data-id="element-887">
                <span className="text-2xl font-medium text-[#2c2418] tracking-widest uppercase" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-888">
                  Swedenmark
                </span>
                <span className="text-sm font-bold text-amber-600 ml-2 tracking-widest" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-889">
                  A.I.
                </span>
              </div>
            </div>
          </div>

          {/* 12. Dark Mode Glow */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-890">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-891">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-892">
                12. Dark Mode Glow
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-893">
                High Contrast / Neon
              </p>
            </div>
            <div className="p-10 flex-1 flex items-center justify-center bg-[#0f1729] relative overflow-hidden" data-id="element-894">
              <div className="absolute w-32 h-32 bg-blue-500/20 rounded-full blur-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-895"></div>
              <div className="flex items-center relative z-10" data-id="element-896">
                <span className="text-2xl font-bold text-white tracking-tight" data-id="element-897">
                  Swedenmark
                </span>
                <span className="text-2xl font-black text-blue-400 ml-1 drop-shadow-[0_0_8px_rgba(96,165,250,0.8)]" data-id="element-898">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}